import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import FactCheck from "@mui/icons-material/FactCheck";
import BathtubIcon from "@mui/icons-material/Bathtub";
import EventIcon from "@mui/icons-material/Event";
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import {
  RUTA_ASISTENCIA_PROYECCIONES,
  RUTA_ASISTENCIA_SPA_PROYECCIONES,
  RUTA_ASISTENCIA_CHECKIN,
  RUTA_ASISTENCIA_SPA_CHECKIN,
} from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-8 col-xxl-6">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-2 p-3">
              {puedeAccederRuta(usuario, RUTA_ASISTENCIA_PROYECCIONES) && (
                <CardCol>
                  <MenuItemCard
                    Icono={CalendarMonth}
                    ruta={RUTA_ASISTENCIA_PROYECCIONES}
                    titulo="Proyecciones"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_ASISTENCIA_SPA_PROYECCIONES) && (
                <CardCol>
                  <MenuItemCard
                    Icono={EventIcon}
                    ruta={RUTA_ASISTENCIA_SPA_PROYECCIONES}
                    titulo="Proyecciones Spa"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_ASISTENCIA_CHECKIN) && (
                <CardCol>
                  <MenuItemCard
                    Icono={FactCheck}
                    ruta={RUTA_ASISTENCIA_CHECKIN}
                    titulo="Check-in"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_ASISTENCIA_SPA_CHECKIN) && (
                <CardCol>
                  <MenuItemCard
                    Icono={BathtubIcon}
                    ruta={RUTA_ASISTENCIA_SPA_CHECKIN}
                    titulo="Check-in spa"
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={6} sm={6} className="mb-2">
      {children}
    </Col>
  );
};

export default CardSection;
